'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inAdvancedCard = inAdvancedCard;
exports.inNormalCard = inNormalCard;
exports.getCardFieldId = getCardFieldId;

var _lodash = require('lodash');

var _constant = require('../vc-face-recognition/constant');

function inAdvancedCard(parents) {
  if ((0, _lodash.isNil)(parents) || !(0, _lodash.isArray)(parents)) {
    return false;
  }

  return parents.some(function (item) {
    return item.componentName === _constant.ADVANCED_CARD_TYPE_NAME;
  });
}

function inNormalCard(parents) {
  if ((0, _lodash.isNil)(parents) || !(0, _lodash.isArray)(parents)) {
    return false;
  }

  return parents.some(function (item) {
    return item.componentName === _constant.CARD_COMPONENT_TYPE_NAME;
  });
}

function getCardFieldId(parentComponents, cardEle) {
  var isAdvancedCard = inAdvancedCard(parentComponents);
  if (isAdvancedCard && inNormalCard(parentComponents)) {
    var advanceCardField = parentComponents.find(function (component) {
      return (0, _lodash.isEqual)(component.componentName, _constant.ADVANCED_CARD_TYPE_NAME);
    });
    return {
      fieldId: (0, _lodash.get)(advanceCardField, 'props.fieldId') + '>' + (0, _lodash.get)(cardEle, 'props.fieldId'),
      inAdvancedCard: isAdvancedCard
    };
  }
  return { fieldId: (0, _lodash.get)(cardEle, 'props.fieldId'), inAdvancedCard: isAdvancedCard };
}